import React, {Component} from 'react';



class Select extends Component {
  constructor(...args){
    super(...args)
    this.state = {}
  }
  
  render(){
    return (
        <div>
          Hello Select class
        </div>
    )
  }
}

export default Select



// WEBPACK FOOTER //
// ./src/component/Select.js